export function disableTwoFingersSwipe() {
    const body =  document.body;
    const html =  document.querySelector('*');
    body?.classList?.add('no-2-fingers-gesture');
    html?.classList?.add('no-2-fingers-gesture');
}

export function enableTwoFingersSwipe() {
    const body =  document.body;
    const html =  document.querySelector('*');
    body?.classList?.remove('no-2-fingers-gesture');
    html?.classList?.remove('no-2-fingers-gesture');
}